
const digest = '771487e64c847bc4335fe2cfd906c1aee789528c3e48e2922cd751758ca42d7d';
const classes = {"button":"_button_2i1el_1","wrapper":"_wrapper_2i1el_9"};
const css = `._button_2i1el_1 {
  font-family: Rubik, "sans-serif";
  color: #1665d8;
  font-size: 14px;
  font-weight: 400;
  text-decoration: underline;
}

._wrapper_2i1el_9 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  